const useLocalCurrency = (
  setCurrency : React.Dispatch<React.SetStateAction<string>>, 
  cadToUsd: boolean = false
) => {
  fetch("https://upsun.com/dynamic/geoip.json")
  // Use ipinfo instead of geoip for testing on local or dev envs
  // fetch(`https://ipinfo.io/json?token=${process.env.GATSBY_IPINFO_TOKEN}`)
    .then((response) => response.json())
    .then((results) => {
      let country = "";
      if ("country" in results) {
        country = results.country;
        switch (country) {
          case "GB":
            setCurrency("GBP");
            break;
          case "US":
          case "UM":
          case "VI":
            setCurrency("USD");
            break;
          case "CA":
            // The fixed pricing page (i.e. the old platform.sh/pricing page)
            // doesn't have CAD and sets Canadian IPs to USD instead
            setCurrency(cadToUsd ? "USD" : "CAD");
            break;
          case "AU":
            setCurrency("AUD");
            break;
          case "CH":
            // setCurrency("CHF");
            setCurrency("EUR");
            break;
          default:
            setCurrency("EUR");
            break;
        }
      }
    })
    .catch((error) => {
      console.log("An error happened fetching geolocation: ", error);
    });
};

export default useLocalCurrency;
